import { Button, FormControl, FormLabel, Grid, HStack, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Textarea } from '@chakra-ui/react'
import WeekCalendar from './WeekCalendar'

interface Props {
	isOpen: boolean
	onClose: () => void
	title: string
	isReschedule?: boolean
}

const BeneficiaryEvent = ({ isOpen, onClose, title, isReschedule = false }: Props) => {
	return (
		<Modal size="lg" onClose={onClose} isOpen={isOpen} isCentered>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{title}</ModalHeader>
				<ModalBody>
					<Grid
						w="full"
						templateColumns={{ sm: "1fr", md: "repeat(1, 1fr)" }}
						gap="12px"
					>
						<FormControl>
							<FormLabel
								fontWeight="bold"
								fontSize="xs"
							>
								Beneficiário
							</FormLabel>
							<Select
								borderRadius="8px"
								fontSize="md"
							>
								<option>Teste</option>
							</Select>
						</FormControl>
						<FormControl>
							<FormLabel
								fontWeight="bold"
								fontSize="xs"
							>
								Compromisso
							</FormLabel>
							<Select
								borderRadius="8px"
								fontSize="md"
							>
								<option>Teste</option>
							</Select>
						</FormControl>
						<FormControl>
							<FormLabel
								fontWeight="bold"
								fontSize="xs"
							>
								Profissional
							</FormLabel>
							<Select
								borderRadius="8px"
								fontSize="md"
							>
								<option>Teste</option>
							</Select>
						</FormControl>
						<FormControl>
							<FormLabel
								fontWeight="bold"
								fontSize="xs"
							>
								Tipo do Agendamento
							</FormLabel>
							<Select
								borderRadius="8px"
								fontSize="md"
							>
								<option>Presencial</option>
								<option>Tele-atendimento</option>
							</Select>
						</FormControl>
						<FormControl>
							<FormLabel
								fontWeight="bold"
								fontSize="xs"
							>
								Duração do Atendimento
							</FormLabel>
							<Select
								borderRadius="8px"
								fontSize="md"
							>
								<option>20 min</option>
								<option>10 min</option>
							</Select>
						</FormControl>
						<FormControl>
							<FormLabel
								fontWeight="bold"
								fontSize="xs"
							>
								Selecione a date e hora
							</FormLabel>
							<WeekCalendar />
						</FormControl>
					</Grid>
				</ModalBody>
				<ModalFooter>
					<HStack spacing={4}>
						<Button variant="ghost" onClick={onClose}>Fechar</Button>
						<Button colorScheme="green" onClick={onClose}>{!isReschedule ? "Agendar" : "Reagendar"}</Button>
					</HStack>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}

export default BeneficiaryEvent
